import React, { useEffect, useState } from 'react';

import { ListType } from '../../../helpers/list-page/interfaces/list-card.interface';
import { useIsMobile } from '../../../hooks/use-is-mobile';
import { ILibraryMeetingPlaceDictionary } from '@/lib/fragments/libraryMeetingPlaceDictionary';
import { PageContext } from '@/templates/page-context.interface';
import IkeaProductCardInHomePage from '../home-page/ikea-product-card';

interface NoHitsProps {
  text: string;
  node_locale?: string;
  pageContext?: PageContext;
  businessUnitCode?: string;
  dictionary?: ILibraryMeetingPlaceDictionary;
  listType?: ListType;
  pageName: string;
}

export const NoHits = ({
  text,
  node_locale,
  pageContext,
  businessUnitCode,
  dictionary,
  listType,
  pageName,
}: NoHitsProps) => {
  const isMobile = useIsMobile();
  const showIkeaProductCard =
    process.env.GATSBY_IKEA_PRODUCT__IS_SHOP_LISTING_PAGE &&
    process.env.NEXT_PUBLIC_IKEA_PRODUCT__IS_SHOP_LISTING_PAGE === 'true' &&
    listType == 'shop'
      ? true
      : false;
  const updatedPageName = pageName + pageContext?.htmlTitleSuffix;

  return (
    <>
      <div
        className={`flex ${showIkeaProductCard ? 'mt-11' : 'h-80'} text-center items-center justify-center font-title text-headingl text-neutral-grey-400 `}
      >
        {text}
      </div>
      {showIkeaProductCard ? (
        <div
          className={
            'mt-5 grid gap-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'
          }
        >
          <div className={'col-span-2 mt-6 min-h-[140px] rounded-md'}>
            <IkeaProductCardInHomePage
              node_locale={node_locale || ''}
              primaryLanguage={pageContext?.languages?.[0]}
              businessUnitCode={businessUnitCode}
              buyNowText={dictionary?.buyAtIkea || ''}
              variant={!isMobile ? 'listing' : 'homepage'}
              cardHeader={dictionary?.featuredIkeaProduct}
              pageName={updatedPageName}
            />
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
